export enum EnBookTab {
  INFO = 'info',
  CHAPTERS = 'chapters',
  COMMENTS = 'comments',
}
